import { BsQuestionCircle } from "react-icons/bs";
import { useState, useEffect } from "react";

// Fallback used before the lookup resolves, and whenever the API/database is
// unreachable or has no configured address for the site.
const DEFAULT_SUPPORT_EMAIL = "info@ias.corpay.com";

// Map the current URL to a site the API understands. The API maps the site to the
// matching 'Key Email Address' config key (USCIS/USPTO/VIP/FX Website Support).
const siteFromPath = (pathname) => {
    const p = (pathname || "").toLowerCase();
    if (p.startsWith("/uscis")) return "uscis";
    if (p.startsWith("/uspto")) return "uspto";
    // Vendor portal and any /vip route (VIP features under the client site) both
    // resolve to VIP Support.
    if (p.startsWith("/vendor") || p.startsWith("/vip")) return "vip";
    return "fx";
};

const NotFound = () => {
    const [supportEmail, setSupportEmail] = useState(DEFAULT_SUPPORT_EMAIL);

    useEffect(() => {
        const site = siteFromPath(window.location.pathname);
        const baseUrl = process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_BASE_URL
            : window.API_URL;

        let active = true;
        fetch(`${baseUrl}/auth/support-email?site=${site}`)
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (active && data && data.email) setSupportEmail(data.email);
            })
            .catch(() => { /* keep DEFAULT_SUPPORT_EMAIL */ });

        return () => { active = false; };
    }, []);

    return (<div align="center" style={{ width:"100%" }}>
        <br/><br/>
        <BsQuestionCircle style={{ fontSize:"5em", color:"var(--corpay-maroon-light)" }} /><br/><br/>
        <div style={{ lineHeight: '28px', fontSize:'16px' }}>
            <h1 style={{ color: '#f38800', fontSize:'1.5em' }}>The Page You Requested Could Not Be Found</h1>
            Please check the URL and try again.<br/><br/>
            If you believe this to be an error,<br/>
            please contact us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </div>
    </div>)
}

export default NotFound
